(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    class HeroSlider {
      constructor(el) {
        this.el = el;
        this.id = el.dataset.heroSlider;
        this.track = el.querySelector('[data-slides-track]');
        this.slides = Array.from(el.querySelectorAll('.hero__slide'));
        this.dots = Array.from(el.querySelectorAll(`[data-slider-dot][data-slider-id="${this.id}"]`));
        this.prevBtn = el.querySelector(`[data-slider-prev="${this.id}"]`);
        this.nextBtn = el.querySelector(`[data-slider-next="${this.id}"]`);
        this.current = 0;
        this.total = this.slides.length;
        this.autoplay = el.dataset.autoplay === 'true';
        this.speed = (parseInt(el.dataset.speed, 10) || 5) * 1000;
        this.timer = null;
        this.isDragging = false;
        this.startX = 0;

        if (this.total < 2) return;
        this.init();
      }

      init() {
        this.prevBtn?.addEventListener('click', () => this.prev());
        this.nextBtn?.addEventListener('click', () => this.next());
        this.dots.forEach((dot) => {
          dot.addEventListener('click', () => this.goTo(parseInt(dot.dataset.sliderDot, 10)));
        });

        // Touch / swipe support
        this.track.addEventListener('touchstart', (e) => {
          this.startX = e.touches[0].clientX;
        }, { passive: true });
        this.track.addEventListener('touchend', (e) => {
          const diff = this.startX - e.changedTouches[0].clientX;
          if (Math.abs(diff) > 40) diff > 0 ? this.next() : this.prev();
        }, { passive: true });

        // Mouse drag support
        this.track.addEventListener('mousedown', (e) => {
          this.isDragging = true;
          this.startX = e.clientX;
          this.track.style.cursor = 'grabbing';
        });
        this.track.addEventListener('mouseup', (e) => {
          if (!this.isDragging) return;
          this.isDragging = false;
          this.track.style.cursor = '';
          const diff = this.startX - e.clientX;
          if (Math.abs(diff) > 40) diff > 0 ? this.next() : this.prev();
        });
        this.track.addEventListener('mouseleave', () => {
          this.isDragging = false;
          this.track.style.cursor = '';
        });

        // Pause autoplay on hover
        this.el.addEventListener('mouseenter', () => this.stopAutoplay());
        this.el.addEventListener('mouseleave', () => {
          if (this.autoplay) this.startAutoplay();
        });

        // Keyboard navigation
        this.el.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowLeft') this.prev();
          if (e.key === 'ArrowRight') this.next();
        });

        if (this.autoplay) this.startAutoplay();

        // Handle visibility change to pause/resume autoplay
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) {
            this.stopAutoplay();
          } else if (this.autoplay) {
            this.startAutoplay();
          }
        });
      }

      goTo(index) {
        const prev = this.current;
        this.current = ((index % this.total) + this.total) % this.total;

        // Update track position
        this.track.style.transform = `translateX(-${this.current * 100}%)`;

        // Update slide aria-hidden
        this.slides[prev]?.setAttribute('aria-hidden', 'true');
        this.slides[prev]?.classList.remove('hero__slide--active');
        this.slides[this.current]?.setAttribute('aria-hidden', 'false');
        this.slides[this.current]?.classList.add('hero__slide--active');

        // Update dots
        this.dots[prev]?.classList.remove('hero__slider-dot--active');
        this.dots[prev]?.setAttribute('aria-selected', 'false');
        this.dots[this.current]?.classList.add('hero__slider-dot--active');
        this.dots[this.current]?.setAttribute('aria-selected', 'true');

        // Manage video playback
        this.slides.forEach((slide, i) => {
          const video = slide.querySelector('video');
          if (!video) return;
          if (i === this.current) {
            video.play().catch(() => {});
          } else {
            video.pause();
          }
        });
      }

      next() { this.goTo(this.current + 1); }
      prev() { this.goTo(this.current - 1); }

      startAutoplay() {
        this.stopAutoplay();
        this.timer = setInterval(() => this.next(), this.speed);
      }

      stopAutoplay() {
        if (this.timer) {
          clearInterval(this.timer);
          this.timer = null;
        }
      }
    }

    function initHeroSliders() {
      document.querySelectorAll('[data-hero-slider]').forEach((el) => {
        if (!el.dataset.heroSliderInit) {
          el.dataset.heroSliderInit = 'true';
          new HeroSlider(el);
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initHeroSliders);
    } else {
      initHeroSliders();
    }

    // Re-init when Shopify theme editor reloads sections
    document.addEventListener('shopify:section:load', initHeroSliders);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
